import React, { useEffect, useState } from 'react'

import { motion } from 'framer-motion'

import { AiOutlineBuild, AiOutlineHome, AiOutlineRobot, AiOutlineProject, AiOutlineCustomerService, AiOutlineCar } from 'react-icons/ai'
import { Link } from 'react-router-dom'


const ExploreServices = [
  {
    title:"Construction",
    icon: <AiOutlineBuild />,
    desc: "Comprehensive construction services from residential to commercial, ensuring quality and sustainability in every project." 
  },
  {
    title: "Real Estate",
    icon: <AiOutlineHome />,
    desc: "We design and build durable, modern homes tailored to comfort, style, and long-term value."
  },
  {
    title: "Engineering",
    icon: <AiOutlineRobot />,
    desc: "Expert infrastructure solutions — from roadworks to drainage systems — built to support sustainable communities."
  },
  {
    title: " Logistics",
    icon: <AiOutlineCar />,
    desc: "We manage the seamless movement of materials, equipment, and supplies — ensuring timely delivery and project flow."
  },
  {
    title: "Consultation",
    icon: <AiOutlineCustomerService />,
    desc: "Our specialists offer strategic guidance and project planning to ensure efficient, cost-effective execution from start to finish."
  },
  {
    title: "Project Management",
    icon: <AiOutlineProject />,
    desc: "We oversee every phase of your project with precision, ensuring quality control, budget alignment, and timely completion."
  }

]



const ExploreBody = () => {
  // Scroll effect for opacity
  const [scrollY, setScrollY] = useState(0);

  const handleScroll = () => {
    setScrollY(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);


  const bgOpacity = Math.min(1, Math.max(0, scrollY / 500));



  return (
    <div
      className='relative bg-cover bg-center bg-no-repeat text-gray-900 py-10'
      style={{
        backgroundImage: 'url(/explore-bg.jpg)',
        opacity: bgOpacity,
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      {/*  Empty Opacity div */}
      <div className='absolute inset-0 bg-white opacity-80 z-10'></div>

      {/* Hero Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='max-w-7xl mx-auto text-center px-6 py-12 relative z-20'
      >
        <h1 className='text-4xl font-bold text-[#29313F] mb-4'>
          Shaping Tomorrow with Smart Solutions
        </h1>

        <p className="text-lg text-gray-600 mb-8">
          Arqelio delivers integrated expertise in construction, civil engineering, consulting, and logistics — all in one trusted place.
        </p>

        <Link to="/services">
          <button className='bg-[#29313F] text-white py-3 px-6 rounded-xl shadow-lg hover:bg-[#1d4ed8] transition-all duration-300'>
            Explore Our Services
          </button>
        </Link>
      </motion.section>

      {/* Services Section with dynamic Cards */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-12 relative z-20'
      >
        {ExploreServices.map((service, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.3 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all hover:scale-105 hover:shadow-xl p-6 flex flex-col items-center text-center"
            >
              <div className="mb-4 text-5xl">
                {service.icon}
              </div>

              <h3 className="text-2xl font-semibold mb-2 text-[#29313F]">
                {service.title}
              </h3>

              <p className='text-gray-600'>
                {service.desc}
              </p>
            </motion.div>
          )
        })}
      </motion.section>

      {/* Call to action */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='bg-[#29313f] text-white py-12 px-6 text-center relative z-20'
      >
        <h2 className='text-3xl font-semibold mb-4'>
          Let’s Build What Matters
        </h2>

        <p className="text-lg mb-6">
          From homes and highway to strategy and supply chains, Arqelio turns ideas into impact. Ready to bring your project to life?
        </p>
        <Link to="/contactus">
          <button className="bg-white text-[#29313F] py-3 px-6 rounded-xl shadow-lg hover:bg-[#d1d5db] hover:text-[#1d4ed8] transition-all duration-300">
            Get in Touch
          </button>
        </Link>
      </motion.section>

      {/* Empty Overlay div */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#1d4ed8] to-transparent opacity-30"></div>
    </div>
  )
}

export default ExploreBody